import React, { useCallback } from 'react';
import styled from 'styled-components';
import Checkbox from 'shared/components/Checkbox';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';

interface RelevancyCheckboxProps {
  text: React.ReactNode;
  value: string;
  handleValue: React.Dispatch<React.SetStateAction<string>>;
}

const StyledDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  .checkbox-field {
    cursor: pointer;
  }
`;

export const defaultCostValue = 'N/A';
export const isCostValid = (cost: string) => {
  return cost && cost !== '0';
};
const RelevancyCheckbox: React.FC<RelevancyCheckboxProps> = ({
  value,
  handleValue,
  text,
}) => {
  const handleToggle = useCallback(() => {
    handleValue(s => (s === defaultCostValue ? '' : defaultCostValue));
  }, [handleValue]);
  return (
    <StyledDiv>
      <TrueImpactText
        variant="body-small"
        className="checkbox-field"
        onClick={handleToggle}
      >
        <Checkbox checked={value === defaultCostValue} />
        {text}
      </TrueImpactText>
    </StyledDiv>
  );
};

export default RelevancyCheckbox;
